const DASH_BACKEND = "http://localhost:3000";

export async function resolveUsername(username) {
  const res = await fetch(`${DASH_BACKEND}/resolve-username`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username }),
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.error || "Username not found");
  return {
    username: data.user.label || username,
    address: data.user.ownerId,
  };
}

export async function sendPayment(username, amountInDash) {
  const res = await fetch(`${DASH_BACKEND}/send-payment`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ toUsername: username, amount: amountInDash }),
  });
  const data = await res.json();
  if (!data.success) throw new Error("Payment failed");
  return { txId: data.txId, username, amount: amountInDash };
}

export async function saveSplit(splitData) {
  const res = await fetch(`${DASH_BACKEND}/save-split`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(splitData),
  });
  const data = await res.json();
  if (!data.success) throw new Error("Failed to save split");
  return {
    documentId: data.splitId,
    explorerUrl: data.explorerUrl || `https://testnet.platform-explorer.com/identity/FViPow8tkY9Lr5TjUWTaQhGK7TpFZ34Vv9Tk12ZGCfTQ`,
    savedAt: new Date().toISOString(),
  };
}